import { UPLOAD_IMAGE_MIN_CROP_SIZE } from '../../../UploadImage.constants'
import {
  clamp,
  isUploadImageCropCornerNE,
  isUploadImageCropCornerNW,
  isUploadImageCropCornerSE,
  isUploadImageCropCornerSW,
} from '../../../UploadImage.utils'

import { DRAG_MODE } from './useCropDrag.constants'

export function isDragModeResize(mode) {
  return mode === DRAG_MODE.RESIZE
}

// Pointer position relative to the stage element's top-left corner.
export function getStagePoint(event) {
  const rect = event.currentTarget.getBoundingClientRect()

  return { x: event.clientX - rect.left, y: event.clientY - rect.top }
}

export function getDragCursor(activeDrag) {
  if (!activeDrag) {
    return null
  }

  if (activeDrag.mode === DRAG_MODE.MOVE) {
    return 'grabbing'
  }

  return isUploadImageCropCornerNW(activeDrag.corner) ||
    isUploadImageCropCornerSE(activeDrag.corner)
    ? 'nwse-resize'
    : 'nesw-resize'
}

// Aspect-locked resize anchored at the corner opposite the one being dragged,
// clamped so the crop never leaves the image.
export function resizeCrop({
  aspect,
  corner,
  layout,
  pointerX,
  pointerY,
  startCrop,
}) {
  const isLeft =
    isUploadImageCropCornerNW(corner) || isUploadImageCropCornerSW(corner)
  const isTop =
    isUploadImageCropCornerNW(corner) || isUploadImageCropCornerNE(corner)

  const anchorX = isLeft ? startCrop.x + startCrop.width : startCrop.x
  const anchorY = isTop ? startCrop.y + startCrop.height : startCrop.y

  const availableWidth = isLeft
    ? anchorX - layout.imageX
    : layout.imageX + layout.displayWidth - anchorX
  const availableHeight = isTop
    ? anchorY - layout.imageY
    : layout.imageY + layout.displayHeight - anchorY

  const maxWidth = Math.min(availableWidth, availableHeight * aspect)
  const desiredWidth = Math.max(
    Math.abs(pointerX - anchorX),
    Math.abs(pointerY - anchorY) * aspect
  )

  const width = clamp(desiredWidth, UPLOAD_IMAGE_MIN_CROP_SIZE, maxWidth)
  const height = width / aspect

  return {
    height,
    width,
    x: isLeft ? anchorX - width : anchorX,
    y: isTop ? anchorY - height : anchorY,
  }
}
